@if (href) {
  <a [class]="classes" [href]="href" [target]="target" (click)="click()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else if (route) {
  <a [class]="classes" [routerLink]="route" [queryParams]="params" [fragment]="fragment" (click)="click()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <button [class]="classes" type="button" (click)="click()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </button>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
